export const CHANGELOADING = 'CHANGELOADING'
export const CHANGELOADINGTEXT = 'CHANGELOADINGTEXT'
export const CHANGEVLOADING = 'CHANGEVLOADING'
export const CHANGEVLOADINGTEXT = 'CHANGEVLOADINGTEXT'
export const SETTOKEN = 'SETTOKEN'
export const SETUSERINFO = 'SETUSERINFO'
